import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { Layout, Seo, Nav, Section, Cta, BookADemoButton } from "../components"
import { ChevronRightIcon } from "@heroicons/react/solid"
import Icon from "../components/icon"

const servicesData = [
  {
    name: "Emergency",
    description:
      "Real-time emergency lighting compliance status across your entire estate.",
    href: "/platform/emergency/",
    icon: (
      <Icon
        className="h-20 w-20 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="siren"
      />
    ),
  },
  {
    name: "Sensors",
    description:
      "Keep on top of air quality in all your buildings at a glance.",
    href: "/platform/sensors/",
    icon: (
      <Icon
        className="h-20 w-20 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="temperature-control"
      />
    ),
  },
  {
    name: "Casambi",
    description:
      "Pull data from your Casambi networks and feed your business intelligence reporting.",
    href: "/platform/casambi/",
    icon: (
      <StaticImage
        src="../assets/images/casambi/casambi-badge-dark.png"
        alt="Building overview of pushfusion"
        placeholder="tracedSVG"
        // layout="fixed"
        quality={100}
        // height={20}
        loading="eager"
        className="w-16 h-auto mb-4"
      />
    ),
  },
]

const NotFoundPage = () => (
  <Layout>
    <Seo title="404: Not found" />
    <div>
      <Nav isHeaderVisible={true} />
      <div className="">
        <Section>
          <div className="bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
            <div className="max-w-max mx-auto">
              <div className="sm:flex">
                <p className="text-4xl font-extrabold text-pushfusion sm:text-5xl">
                  404
                </p>
                <div className="sm:ml-6">
                  <div className="sm:border-l sm:border-gray-200 sm:pl-6">
                    <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                      Page not found
                    </h1>
                    <p className="mt-1 text-base text-gray-500">
                      We’re really sorry, but the page you’re trying to view
                      doesn’t seem to exist.
                    </p>
                  </div>
                  <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
                    <Link
                      to="/"
                      className="text-base font-medium text-pushfusion hover:text-pushfusion-darker"
                    >
                      Go back home<span aria-hidden="true"> &rarr;</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="mt-20 sm:mt-28">
                <h2 className="text-sm font-semibold text-gray-500 tracking-wide uppercase">
                  Platform
                </h2>

                <ul className="mt-4 border-t border-b border-gray-200 divide-y divide-gray-200 max-w-3xl">
                  {servicesData.map((service, linkIdx) => (
                    <li
                      key={linkIdx}
                      className="relative py-6 flex items-start space-x-4"
                    >
                      <div className="flex-shrink-0">
                        <span className="flex items-center justify-center h-12 w-12 rounded-lg bg-orange-brand">
                          {service.icon}
                        </span>
                      </div>

                      <div className="min-w-0 flex-1">
                        <h3 className="text-base font-medium text-gray-900">
                          <Link
                            to={service.href}
                            className="focus:outline-none"
                          >
                            <span
                              className="absolute inset-0"
                              aria-hidden="true"
                            />
                            {service.name}
                          </Link>
                        </h3>
                        <p className="text-base text-gray-500">
                          {service.description}
                        </p>
                      </div>
                      <div className="flex-shrink-0 self-center">
                        <ChevronRightIcon
                          className="h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Section>
        <Cta
          title="Interested in learning more about"
          subtitle="the benefits of pushfusion?"
          button1={
            <BookADemoButton
              background="bg-gray-50"
              backgroundHover="bg-gray-300"
              textColor="text-pushfusion"
            />
          }
        />
      </div>
    </div>
  </Layout>
)

export default NotFoundPage
